import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { faEye, faImage, faTrash } from "@fortawesome/free-solid-svg-icons";
import { MODAL_TYPE } from "../strings";
import { ContainObjFitImg } from "../common-styling";
import { showError } from "../../services/toast-service";
import ViewGalleryModal from "../gallery/view-gallery-modal";
import SearchImageModal from "../gallery/search-image-modal";
import CreateGalleryModal from "../gallery/create-gallery-modal";
import ImagePreviewModal from "../funnel-form/preview-image-modal";
import ValidationMessage from "../validation-message/validation-message";
import { useTranslation } from "react-i18next";

const IconContainer = styled.div`
  flex: 1;
  margin-right: 15px;
  padding-left: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #c0c4c5;
`;
const FAIcon = styled(FontAwesomeIcon)`
  color: #616568;
  font-size: 40px;
`;
const FixedWidthImgDiv = styled.div`
  width: 68px;
  height: 54px;
`;

const FileInput = (props) => {
  const { t } = useTranslation();
  const [showPreview, setShowPreview] = useState(false);
  const tags = useSelector((state) => state.tags);
  const selectedTags = tags.tags.find((tag) => tag.name === props.tagName);
  const [showViewGalleryModal, setShowViewGalleryModal] = useState(false);
  const [showSearchGalleryModal, setShowSearchGalleryModal] = useState(false);
  const [showCreateGalleryModal, setShowCreateGalleryModal] = useState(false);
  const { setValue, register } = useFormContext();
  const toggleModal = (modal) => {
    if (modal === MODAL_TYPE.VIEW) {
      setShowViewGalleryModal(!showViewGalleryModal);
      setShowCreateGalleryModal(false);
      setShowSearchGalleryModal(false);
    } else if (modal === MODAL_TYPE.SEARCH) {
      setShowSearchGalleryModal(!showSearchGalleryModal);
      setShowViewGalleryModal(false);
    } else if (modal === MODAL_TYPE.CREATE) {
      setShowCreateGalleryModal(!showCreateGalleryModal);
      setShowViewGalleryModal(false);
    } else {
      setShowViewGalleryModal(false);
      setShowCreateGalleryModal(false);
      setShowSearchGalleryModal(false);
    }
  };

  const selectImage = ({ url, key, _id }) => {
    try {
      const fieldObj = { key, url, _id, asset: _id };
      setValue(props.name, fieldObj, { shouldDirty: true });
      toggleModal();
      if (props.isFormChanged) {
        props.isFormChanged.current = true;
      }
    } catch (error) {
      showError(
        error?.response?.data?.message || t("toastMessage.selectAssetError")
      );
    }
  };
  return (
    <div className="mb-4">
      <div className="d-flex">
        <div className={`mb-2 ${props.error ? "text-danger fw-bold" : ""}`}>
          {props.label}
        </div>
        {props.setDisplay && (
          <div className="ms-2">
            {props.switchLabel && (
              <Form.Label
                htmlFor={props.fieldWatcherName}
                className="form-check-label ms-5 me-2"
              >
                {props.switchLabel}
              </Form.Label>
            )}
            <OverlayTrigger
              overlay={
                <Tooltip>
                  {props.fieldWatcherName === "design.partnerLogoDisplay"
                    ? props.displayFieldWatcher
                      ? "Display On"
                      : "Display Off"
                    : props.displayFieldWatcher
                      ? "Unclip Image"
                      : "Clip Image"}
                  {/* {logoDisplay ? "Display On" : "Display Off"} */}
                </Tooltip>
              }
            >
              <Form.Check
                role="button"
                type="switch"
                {...register(props.fieldWatcherName)}
                className="float-end"
              />
            </OverlayTrigger>
          </div>
        )}
      </div>
      <div className="d-flex align-items-center">
        <IconContainer>
          {props.url ? (
            <FixedWidthImgDiv>
              <ContainObjFitImg src={props.url} />
            </FixedWidthImgDiv>
          ) : (
            <FAIcon icon={faImage} />
          )}
        </IconContainer>
        {props?.urlForPreview && (
          <>
            <Button
              variant="outline-secondary me-2"
              onClick={() => setShowPreview(!showPreview)}
            >
              <FontAwesomeIcon icon={faEye} />
            </Button>
            {showPreview && (
              <ImagePreviewModal
                source={props.urlForPreview}
                toggleModal={() => setShowPreview(!showPreview)}
              />
            )}
          </>
        )}
        <Button
          onClick={() => toggleModal(MODAL_TYPE.VIEW)}
          variant="outline-secondary"
        >
          {t("searchImage")}
        </Button>
        {props.isRemoveAllowed && (
          <Button
            onClick={() => props.removeImage(props.removeId)}
            variant="outline-danger mx-2"
            disabled={props.removeBtnDisabled}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}

        {showCreateGalleryModal && (
          <CreateGalleryModal
            onFinish={selectImage}
            onClose={() => toggleModal(MODAL_TYPE.CREATE)}
          />
        )}

        {showSearchGalleryModal && (
          <SearchImageModal
            onFinish={selectImage}
            onClose={() => toggleModal(MODAL_TYPE.SEARCH)}
          />
        )}

        {showViewGalleryModal && (
          <ViewGalleryModal
            tagsSelected={selectedTags ? [selectedTags] : []}
            selectedCategory={props.selectedCategory}
            selectImage={selectImage}
            handleClose={() => toggleModal(MODAL_TYPE.VIEW)}
            toggleAddImage={() => toggleModal(MODAL_TYPE.CREATE)}
            toggleSearchImage={() => toggleModal(MODAL_TYPE.SEARCH)}
          />
        )}
      </div>
      {props.error?.message && (
        <ValidationMessage error={props.error.message} />
      )}
    </div>
  );
};
export default FileInput;
